export const customStyles = {
  control: (base, state) => ({
    ...base,
    height: "38px",
    // minWidth: "172px",
    width: "180px",
    fontSize: "14px",
    boxShadow: state.isFocused
      ? "0px 5.09687px 11.8927px rgba(150, 185, 255, 0.25)"
      : "0px 2px 5px rgba(38, 51, 77, 0.03)",
    borderColor: "#EEEEEE",
    "&:hover": { borderColor: "none" }, // border style on hover
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color: state.isSelected ? "#F47F20" : "#B5B5C3",
    backgroundColor: state.isSelected
      ? "#F5F6FC"
      : state.isFocused
      ? "#fff"
      : provided.backgroundColor,
    "&:hover": {
      backgroundColor: "#F5F6FC",
      color: "#F47F20",
    },
  }),
};

export const sortingOptions = [
  { value: "", label: "Default Sorting" },
  {
    value: "sbp",
    label: "Sort by Popularity",
  },
  {
    value: "sbtfLH",
    label: "Sort by Tution Frees Low to High",
  },
  {
    value: "sbtfHL",
    label: "Sort by Tution Frees High to Low",
  },
  {
    value: "sbr",
    label: "Sort by Rating",
  },
];
